import { useEffect, useMemo, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { getJeepRallyMediaUrl } from "../../../../../api/jeep-rally/api";

const TypeImageField = ({
  label = "Image",
  imagePath = "",
  imageFile = null,
  disabled = false,
  error = "",
  onFileChange,
}) => {
  const inputRef = useRef(null);

  const filePreviewUrl = useMemo(() => {
    if (!(imageFile instanceof File)) return "";
    return URL.createObjectURL(imageFile);
  }, [imageFile]);

  useEffect(() => {
    return () => {
      if (filePreviewUrl) URL.revokeObjectURL(filePreviewUrl);
    };
  }, [filePreviewUrl]);

  const previewUrl = filePreviewUrl || getJeepRallyMediaUrl(imagePath);

  const handlePick = (event) => {
    const file = event.target.files?.[0] || null;
    event.target.value = "";
    if (!file || disabled) return;
    onFileChange(file);
  };

  return (
    <Form.Group className="mb-3">
      {label ? <Form.Label>{label}</Form.Label> : null}

      <div className="d-flex flex-wrap gap-3 align-items-start">
        <div
          className="d-flex align-items-center justify-content-center overflow-hidden"
          style={{
            width: 120,
            height: 80,
            borderRadius: 6,
            border: "1px solid #dee2e6",
            flexShrink: 0,
          }}
        >
          {previewUrl ? (
            <img
              src={previewUrl}
              alt={label || "Preview"}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <span className="text-muted small">No file</span>
          )}
        </div>

        <div className="flex-grow-1" style={{ minWidth: 200 }}>
          <div className="mb-2 px-2 py-2 border rounded small text-break">
            {imageFile?.name ? (
              <code className="text-body">{imageFile.name}</code>
            ) : imagePath ? (
              <code className="text-body">{imagePath}</code>
            ) : (
              <span className="text-muted">No image yet — upload a file</span>
            )}
          </div>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            className="d-none"
            onChange={handlePick}
            disabled={disabled}
          />
          <Button
            type="button"
            size="sm"
            variant="outline-primary"
            disabled={disabled}
            onClick={() => inputRef.current?.click()}
          >
            {imagePath || imageFile ? "Replace image" : "Upload image"}
          </Button>
          {error ? (
            <div className="text-danger small mt-1">{error}</div>
          ) : (
            <div className="form-text">
              Optional. Sent as multipart field <code>image</code>.
            </div>
          )}
        </div>
      </div>
    </Form.Group>
  );
};

export default TypeImageField;
